import React from "react";
import { Card, H1, H3, Text } from "@blueprintjs/core";
import { inject, observer } from "mobx-react";

class IPDAppointment extends React.Component {
  render() {
    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "var(--bg-primary)",
          color: "var(--text-primary)",
          minHeight: "100vh",
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          <H1 style={{ color: "var(--text-primary)", margin: 0 }}>IPD Appointment</H1>
          <Text
            style={{
              color: "var(--text-secondary)",
              margin: "5px 0",
              fontSize: "16px",
            }}
          >
            Schedule and manage Inpatient Department appointments and consultations
          </Text>
        </div>

        <Card
          elevation={2}
          style={{
            padding: "30px",
            backgroundColor: "var(--bg-surface)",
            border: "1px solid var(--border-color)",
          }}
        >
          <H3 style={{ color: "var(--text-primary)", marginBottom: "15px" }}>IPD Appointment Report</H3>
          <Text style={{ color: "var(--text-secondary)", lineHeight: "1.6" }}>
            This page will provide comprehensive IPD appointment management including:
          </Text>
          <ul
            style={{
              color: "var(--text-secondary)",
              marginTop: "15px",
              paddingLeft: "20px",
              lineHeight: "1.8",
            }}
          >
            <li>IPD patient appointment scheduling and management</li>
            <li>Doctor availability and consultation scheduling</li>
            <li>Appointment reminders and notifications</li>
            <li>Follow-up appointment tracking and management</li>
            <li>Appointment status monitoring and updates</li>
            <li>Calendar view for IPD appointments and consultations</li>
            <li>Patient appointment history and records</li>
          </ul>
          <Text
            style={{
              color: "var(--text-secondary)",
              marginTop: "20px",
              fontStyle: "italic",
            }}
          >
            This is a placeholder page. Full functionality will be implemented later.
          </Text>
        </Card>
      </div>
    );
  }
}

export default inject("authStore")(observer(IPDAppointment));
